<template>
    <ul class="list list-unstyled tw-m-0 tw-space-y-4">
        <li
            v-for="(skill, index) in insights"
            :key="skill.name"
            class="tw-flex tw-items-center tw-align-middle tw-space-x-4"
        >
            <div
                v-b-popover.top.hover="skill.name.length > 30 ? skill.name : ''"
                class="tw-truncate tw-w-1/3 tw-text-sm tw-text-gray-500"
            >
                {{ skill.name }}
            </div>
            <div
                class="tw-flex-1 tw-bg-indigo-50 tw-rounded-sm tw-overflow-hidden tw-h-5 tw-relative tw-shadow-inner"
            >
                <div
                    class="tw-transition-all tw-duration-1000 tw-h-3 tw-bg-indigo-500 tw-shadow-inner"
                    :style="{
                        width: enabled ? `${(skill.amount * 100) / insights[0].amount}%` : '0px',
                    }"
                ></div>
                <div
                    v-b-popover.top.hover="
                        !skill.negativeResponses &&
                        !skill.neutralResponses &&
                        !skill.positiveResponses
                            ? $t('feedback.analytics.skillInsights.waitingForInput')
                            : ''
                    "
                    class="tw-absolute tw-flex tw-bottom-0 tw-left-0 tw-right-0 tw-h-2 tw-bg-gray-100 tw-border-0 tw-border-t tw-border-solid tw-border-white"
                >
                    <div
                        v-for="type in [
                            'negativeResponses',
                            'neutralResponses',
                            'positiveResponses',
                        ]"
                        :key="type"
                        v-b-popover.top.hover="
                            type === 'negativeResponses'
                                ? $t('feedback.analytics.skillInsights.negativeResponse')
                                : type === 'neutralResponses'
                                ? $t('feedback.analytics.skillInsights.neutralResponse')
                                : $t('feedback.analytics.skillInsights.positiveResponse')
                        "
                        class="tw-transition-all tw-duration-1000 tw-h-2 tw-opacity-90"
                        :style="{
                            width: enabled
                                ? `${(skill[type] * 100) / insights[index].amount}%`
                                : '0px',
                        }"
                        :class="[
                            type === 'negativeResponses'
                                ? 'tw-bg-yellow-300'
                                : type === 'neutralResponses'
                                ? 'tw-bg-gray-300'
                                : 'tw-bg-green-300',
                        ]"
                    ></div>
                </div>
            </div>

            <div class="tw-font-bold tw-text-gray-400">
                {{ skill.amount }}
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        insights: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            enabled: false,
        };
    },
    mounted() {
        // Allow our css animation (bar width) to be triggered and
        // be visible to the user
        setTimeout(() => {
            this.enabled = true;
        }, 200);
    },
};
</script>
